import { BaseService } from "../../../../../global/classes";
import {
  AnticipationRequest,
  FormValues,
  IReceivable,
  SimulationRequest,
} from "../types";
import { bffApi } from "../../../../../services/bff/bffApi";
import { mapReceivablesToAnticipationRequests } from "../../../utils";

export default class AnticipationService extends BaseService {
  getReceivablesToAnticipate = async (filter?: FormValues) => {
    const initDate = filter?.initialDate || null;
    const finishDate = filter?.finalDate || null;
    const merchantId = filter?.merchantId || null;

    try {
      const response = await bffApi.get(
        `/api/flux/v1/anticipated-receivables/receivables`,
        {
          params: {
            initDate: initDate,
            finishDate: finishDate,
            merchantId: merchantId,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  anticipateReceivables = async (receivables: IReceivable[]) => {
    let request: any[] = [];
    if (receivables.length > 0) {
      request = mapReceivablesToAnticipationRequests(receivables);
    }

    return bffApi.post(
      `/api/gcb/v1/anticipation/anticipate`,
      {
        receivables: [...request],
      }
    );
  };

  simulateAnticipation = async (request: SimulationRequest) => {
    try {
      const response = await bffApi.post(
        `/api/gcb/v1/anticipation/anticipate`,
        request
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  downloadAnticipationPdf = async (request?: SimulationRequest) => {
    try {
      const response = await bffApi.post(
        `/api/gcb/v1/anticipation/download-simulation`,
        request,
        {
          responseType: "blob",
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  downloadAnticipationFomenti = async (request?: SimulationRequest) => {
    try {
      const response = await bffApi.post(
        `/api/gcb/v1/anticipation/download-fomenti-report`,
        request,
        {
          responseType: "blob",
        }
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };

  confirmAnticipation = async (request: SimulationRequest) => {
    try {
      const response = await bffApi.post(
        `/api/gcb/v1/anticipation/confirm-anticipation`,
        request
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  };
}
